//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AgentsSelect from "../../../../../../agents/components/agents-select";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ESignSelectAgentPage",
  components: {
    AgentsSelect
  },
  mixins: [validationMixin],
  props: {
    agentUsername: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      requesterAgent: this.agentUsername,
      loadingAgents: true
    };
  },
  validations: {
    requesterAgent: {
      required
    }
  },
  computed: {
    isValid() {
      return !this.$v.$invalid && !this.loadingAgents;
    }
  },
  watch: {
    isValid: {
      handler(value) {
        this.$emit("valid", value);
      },
      immediate: true
    }
  },
  methods: {
    handleChange({
      username: agent
    }, type) {
      switch (type) {
        case "select":
          this.requesterAgent = agent;
          this.$emit("change-requester", this.requesterAgent);
          break;
      }
    },
    handleLoadingAgents(loading) {
      this.loadingAgents = loading;
    }
  }
});